const restoreLinebreaks = (string: string) =>
  (string = string.replace(/\n{3,}/g, '\n\n').replace(/\n/g, '<br>'));

export default restoreLinebreaks;
